import React from 'react';
import { Reveal } from './Reveal';
const steps = [{
  number: '01',
  title: 'Conversamos',
  text: 'Conoce cómo funciona, haz tus preguntas y descubre si encaja contigo.'
}, {
  number: '02',
  title: 'Conoces el proceso',
  text: 'Te explicamos la industria, la capacitación y los requisitos necesarios para comenzar.'
}, {
  number: '03',
  title: 'Tú decides',
  text: 'Si tiene sentido para ti, podrás conocer cuáles serían los siguientes pasos.'
}];
export function HowItWorks() {
  return <section className="w-full bg-ivory py-24 sm:py-32 lg:py-40" aria-labelledby="how-title" data-id="element-138" data-mp="qiv2r2s3zbxj">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-139" data-mp="crpytohpjxhe">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-24" data-id="element-140" data-mp="gsi82hqky2do">
          <Reveal data-id="element-141" data-mp="14iw048960189">
            <p className="font-sans text-[10px] font-medium uppercase tracking-widest2 text-champagne sm:text-[11px]" data-id="element-142" data-mp="14icjqvz5xkwc">
              Tu primer paso
            </p>
            <h2 id="how-title" className="mt-8 font-sans text-[1.85rem] font-light uppercase leading-[1.12] text-ink sm:text-[2.5rem]" data-id="element-143" data-mp="2rl4r8sc53kz5">
              Conocer es el
              <br data-id="element-144" data-mp="31bzg84grsyoa" />
              primer paso.
            </h2>
          </Reveal>

          <div className="border-l border-ink/12 pl-8 sm:pl-12" data-id="element-145" data-mp="2wl0w0tsnvgfr">
            {steps.map((step, i) => <Reveal key={step.number} delay={i * 0.08} data-id="element-146" data-mp="3abvxhl0tyv9b" data-mpi={i}>
                <div className={i > 0 ? 'mt-12 sm:mt-14' : ''} data-id="element-147" data-mp="3aachzwn00o8l">
                  <span className="block font-serif text-3xl text-champagne sm:text-4xl" data-id="element-148" data-mp="369isiytwr1dl">
                    {step.number}
                  </span>
                  <h3 className="mt-5 font-sans text-sm font-medium uppercase tracking-[0.2em] text-ink" data-id="element-149" data-mp="3k7zajlx80eb1">
                    {step.title}
                  </h3>
                  <p className="mt-3 max-w-md font-sans text-base font-light leading-relaxed text-steel sm:text-[17px]" data-id="element-150" data-mp="1px3pvl8rh8rw">
                    {step.text}
                  </p>
                </div>
              </Reveal>)}
          </div>
        </div>
      </div>
    </section>;
}